import { OutOfCoreTaskBase } from "../OutOfCoreTaskBase";

import { ConsolidationTask } from './ConsolidationTask';
import { UploadTaskBase } from './UploadTaskBase';

/** @import { OutOfCoreTileManager } from "../OutOfCoreTileManager" */

export class WebGLUploadTask extends OutOfCoreTaskBase {

  /**
   *
   * @param {OutOfCoreTileManager} outOfCoreTileManager The OutOfCoreTileManager instance
   * @param {BvhNode} node The BVH node
   */
  constructor(outOfCoreTileManager, node) {
    super(outOfCoreTileManager);

    this.node = node;
    this._initSubTasks();
  }

  /**
   * Creates consolidation and instancing tasks for the meshes in the node. This should probably be refactored once we get rid of the
   * non-node based consolidation and don't require thes other task classes anymore.
   */
  _initSubTasks() {
    this.subTasks = [];
    const consolidation = this.node.model.getConsolidation(this.node.nodeId);
    for (let i = 0; i < consolidation.meshes.length; i++) {
      if (!consolidation.meshes[i].geometry) {
        return;
      }

      // Is it a consolidated mesh?
      if (!consolidation.meshGeometryAvailable(i)) {
        this.subTasks.push(new ConsolidationTask(
          this.node.outOfCoreTileManager,
          i,
          this.node.model.getFragmentList(),
          this.node.nodeId
        ));
      }

      let geometry = consolidation.meshes[i].geometry;
      // Is it an instanced mesh?
      if (geometry.numInstances > 1) {
        this.subTasks.push(new UploadTaskBase(
          this.node.outOfCoreTileManager,
          null,
          this.node.nodeId,
          [geometry]
        ));
      }
    }
  }

  *execute() {
    for (const task of this.subTasks) {
      yield task.execute();
    }
  }

  /**
   * Frees the memory consumed by the task
   */
  undo() {
    for (const task of this.subTasks) {
      task.undo();
    }
  }

  /**
   * Returns the resource cost of the task
   * @returns {number} The resource cost of the task
   */
  getResourceCost() {
    let cost = 0;
    for (const task of this.subTasks) {
      cost += task.getResourceCost();
    }
    return cost;
  }
}